'use strict';

import _ from 'lodash';

class ParkerStatusHistory {
    fields = {
        id: {
            value: null
        },
        parker_id: {
            value: null
        },
        action: {
            value: null
        },
        start_date: {
            value: null
        },
        end_date: {
            value: null
        },
        notes: {
            value: null
        },
        created_at: {
            value: null
        },
        updated_at: {
            value: null
        }
    };

    static getQueryFieldValues(parkerStatusHistory) {
        const values = _.cloneDeep(ParkerStatusHistoryInput);

        for (const field in values) {
            values[field] = parkerStatusHistory[field];
        }

        return values;
    }
}

const ParkerStatusHistoryInput = {
    id: null,
    parker_id: null,
    action: null,
    start_date: null,
    end_date: null,
    notes: null
};

export default ParkerStatusHistory;
